import { Component, inject, Input } from '@angular/core';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-blob',
  imports: [
    ButtonDirective,
    TranslatePipe
  ],
  templateUrl: './error-blob.component.html',
  styleUrl: './error-blob.component.css'
})
export class ErrorBlobComponent {
  @Input() public errorCode: string = '404';

  public router: Router = inject(Router);

  public colors: string[] = [
    'text-theme-primary',
    'text-teal-500',
    'text-yellow-500',
    'text-purple-300',
    'text-blue-200'
  ];

}
